var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_66",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 29.25C29.175 29.25 31.0312 28.4813 32.5688 26.9438C34.1063 25.4062 34.875 23.55 34.875 21.375C34.875 19.2 34.1063 17.3438 32.5688 15.8063C31.0312 14.2688 29.175 13.5 27 13.5C24.825 13.5 22.9688 14.2688 21.4313 15.8063C19.8938 17.3438 19.125 19.2 19.125 21.375C19.125 23.55 19.8938 25.4062 21.4313 26.9438C22.9688 28.4813 24.825 29.25 27 29.25ZM11.25 47.25C10.0125 47.25 8.95312 46.8094 8.07188 45.9281C7.19063 45.0469 6.75 43.9875 6.75 42.75V11.25C6.75 10.0125 7.19063 8.95312 8.07188 8.07188C8.95312 7.19063 10.0125 6.75 11.25 6.75H42.75C43.9875 6.75 45.0469 7.19063 45.9281 8.07188C46.8094 8.95312 47.25 10.0125 47.25 11.25V42.75C47.25 43.9875 46.8094 45.0469 45.9281 45.9281C45.0469 46.8094 43.9875 47.25 42.75 47.25H11.25ZM11.25 42.75H42.75V40.1625C40.725 38.175 38.3719 36.6094 35.6906 35.4656C33.0094 34.3219 30.1125 33.75 27 33.75C23.8875 33.75 20.9906 34.3219 18.3094 35.4656C15.6281 36.6094 13.275 38.175 11.25 40.1625V42.75Z",
    fill: "#454F41"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8cc1316797c9be0a582c3b4d64285811.svg";
export { ForwardRef as ReactComponent };